import { render, staticRenderFns } from "./InfoSetting.vue?vue&type=template&id=5e18052c&scoped=true"
import script from "./InfoSetting.vue?vue&type=script&lang=js"
export * from "./InfoSetting.vue?vue&type=script&lang=js"
import style0 from "./InfoSetting.vue?vue&type=style&index=0&id=5e18052c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e18052c",
  null
  
)

export default component.exports